import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ResourceDetailsBaseComponent } from '../resource-details-base/resource-details-base.component';

@Component({
    selector: 'app-resource-details-test',
    templateUrl: './resource-details-test.component.html',
    styleUrls: ['./resource-details-test.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceDetailsTestComponent extends ResourceDetailsBaseComponent {
    constructor() {
        super();
    }
}
